export default __webpack_public_path__ + "static/media/nguphu.138dec2b.png";